import React from "react";

function HeaderButton({name}) {
  return (
    <button className="bg-slate-950 text-white py-2 px-4 rounded absolute top-2 right-4 hover:bg-slate-700">
     {name}
    </button>
  );
}

export default HeaderButton;